import React, { useImperativeHandle, useRef, forwardRef } from "react";
import { default as ReCaptcha } from "react-google-recaptcha";
import ConfigService from "../../Services/ConfigService";
import {
  ENV_TEST,
  GOOGLE_CAPTCHA_INTERNAL_ERROR,
  GOOGLE_CAPTCHA_SITE_KEY,
  INVISIBLE,
  MOCK_TOKEN,
} from "../../Constants/CommonConstants";
import { useDispatch } from "react-redux";
import {
  closeProgressModal,
  openProgressModal,
} from "../../Features/UtilityDataSlice";

/**
 * GoogleReCaptcha component provides a wrapper for the Google reCaptcha integration.
 *
 * @returns {JSX.Element} - Rendered reCaptcha component.
 */
const GoogleReCaptcha = (_, ref) => {
  const reCaptchaRef = useRef();

  const dispatch = useDispatch();

  const reCaptchaSiteKey = ConfigService(GOOGLE_CAPTCHA_SITE_KEY);

  //Expose a method to the parent component using useImperativeHandle
  useImperativeHandle(ref, () => ({
    /**
     * Asynchronous method to trigger reCaptcha execution and retrieve the token.
     * Resets the reCaptcha after token retrieval.
     */
    async onSubmitWithReCAPTCHA() {
      dispatch(openProgressModal());
      const token =
        process.env.NODE_ENV === ENV_TEST
          ? MOCK_TOKEN
          : await reCaptchaRef.current.executeAsync();
      dispatch(closeProgressModal());
      if (token) {
        return token;
      }
      throw GOOGLE_CAPTCHA_INTERNAL_ERROR;
    },

    async onResetReCAPTCHA() {
      await reCaptchaRef.current.reset()
    }
  }));

  return (
    <ReCaptcha
      ref={reCaptchaRef}
      sitekey={reCaptchaSiteKey}
      size={INVISIBLE}
      aria-hidden={true}
    />
  );
};

export default forwardRef(GoogleReCaptcha);
